import colors from '@/assets/styles/_export.scss';

const attachVariables = (Vue, variables, wrappingObject, excludedVariables = []) => {
  const filteredKeys = Object.keys(variables).filter(key => !excludedVariables.includes(key));
  const object = filteredKeys.reduce((total, key) => {
    return Object.defineProperty(total, key, {
      value: Object.freeze(variables[key]),
    });
  }, {});
  const prefixedWrappingObject = `$_${wrappingObject}`;
  Object.assign(Vue.prototype, { [prefixedWrappingObject]: object });
};

export default {
  install(Vue) {
    attachVariables(Vue, colors, 'colors');
  },
};
